import MuiSlider from "@mui/material/Slider";
import { sliderStyles } from "./Slider.styles";
import styles from "./Slider.module.scss";
import { Dispatch, SetStateAction, useEffect } from "react";
import { useTranslation } from "react-i18next";
import CheckBox from "../CheckBox/CheckBox";

interface SliderProps {
  onChange: (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => void;
  ariaLabelledby: string;
  value: number;
  setValue: Dispatch<SetStateAction<number>>;
  title: string;
  max: number;
  moreThanEightQuestion?: boolean;
  toggleIsMoreThanEight: () => void;
  isMoreThanEight: boolean;
}

export default function Slider(props: SliderProps) {
  const {
    onChange,
    ariaLabelledby,
    value,
    setValue,
    title,
    max,
    moreThanEightQuestion,
    toggleIsMoreThanEight,
    isMoreThanEight,
  } = props;

  const { t } = useTranslation();

  const marksToDisplay = [
    { value: 2 },
    { value: 3 },
    { value: 4 },
    { value: 5 },
    { value: 6 },
    { value: 7 },
  ];

  const handleIncrement = () => {
    if (value < max) {
      setValue(value + 1);
    }
  };

  const handleDecrement = () => {
    if (value > 1) {
      setValue(value - 1);
    }
  };

  useEffect(() => {
    if (value > max) {
      setValue(max);
    }
  }, [max]);

  useEffect(() => {
    if (value === 0) {
      setValue(1);
    }
  }, [isMoreThanEight]);

  const slicedMarksToDisplay = marksToDisplay.slice(0, max - 2);

  return (
    <div className={styles.sliderWrapper}>
      <div className={styles.sliderDescriptionContainer}>
        <p className={`body-medium ${styles.sliderDescription}`}>{title}</p>
        {moreThanEightQuestion && (
          <div className={styles.sliderAdditionalQuestionContainer}>
            <CheckBox
              checked={isMoreThanEight}
              toggleChecked={toggleIsMoreThanEight}
              label={t("gradientDrawer.divideBillEqually.moreThanEight")}
              labelSide="left"
            />
          </div>
        )}
      </div>
      <div className={styles.sliderContainer}>
        <i
          className={`las la-minus-circle icon-big ${styles.sliderIcon}`}
          onClick={handleDecrement}
        />
        {isMoreThanEight ? (
          <p className={`body-bold-large ${styles.sliderValue}`}>{value}</p>
        ) : (
          <MuiSlider
            sx={sliderStyles}
            value={value}
            aria-labelledby={ariaLabelledby}
            aria-label={ariaLabelledby}
            defaultValue={0}
            valueLabelDisplay="auto"
            step={1}
            min={1}
            max={max}
            marks={slicedMarksToDisplay}
            onChange={onChange}
          />
        )}
        <i
          className={`las la-plus-circle icon-big ${styles.sliderIcon}`}
          onClick={handleIncrement}
        />
      </div>
    </div>
  );
}
